import { withInstall } from '@ll-plus/utils'

import RichTextEditor from './src/rich-text-editor.vue'
//@ts-ignore
export const LlRichTextEditor = withInstall(RichTextEditor)
export default LlRichTextEditor
export * from './src/rich-text-editor'

declare module 'vue' {
  export interface GlobalComponents {
    LlRichTextEditor: typeof RichTextEditor
  }
}
